import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';
import { Product, CartItem } from '../../models/shop.model';

export const type = 'shop';

export interface ShopState extends EntityState<Product, string> {
    isFetching: boolean;
    hasFetched: boolean;
    errorMessage?: string;
    cart: CartItem[];
    paymentUrl?: string;
    proforma?: any;
    proformaStatus?: {
        isPaid: boolean;
        isFulfilled?: boolean;
        fulfilmentFailed?: boolean;
        nextAction?: 'pending' | 'book' | 'home' | 'fulfilment_failed';
        canCheckAgain?: boolean;
        canBook?: boolean;
        message?: string;
        bookableProfilePackageId?: number | null;
        checkedAt: string;
        error?: boolean;
    };
}

export const adapter = createEntityAdapter<Product, string>({
    selectId: (product: Product) => product.productKey,
});

export const initialState: ShopState = adapter.getInitialState({
    isFetching: false,
    hasFetched: false,
    errorMessage: undefined,
    cart: [],
    paymentUrl: undefined,
    proforma: undefined,
    proformaStatus: undefined,
});
